import { Component, Prop, Vue } from 'vue-property-decorator'
import {
    ReportModelEnum,
    ReportModelConfigurationMatch
} from '@/modules/printModule/services/report-model-configuration/report-model-configuration.model'
import { AvailablePrinter } from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'
import { UserType } from '@/api/resources/common/initialization/common-initialization.dto'

@Component
export default class UserConfigurationPrintTabReportModel extends Vue {
    @Prop() readonly reportModels!: ReportModelConfigurationMatch[]
    @Prop() readonly printers!: AvailablePrinter[]

    get isPersonnel(): boolean {
        return this.$store.getters.userInformation?.userType === UserType.PERSONNEL
    }

    onSelectPrinter(): void {
        this.$forceUpdate()
    }

    hasPathPlaceholder(reportModel: ReportModelConfigurationMatch): boolean {
        return reportModel.isDefault &&
            reportModel.reportModel === ReportModelEnum.PRINTMATE_CASSETTE_PARAFFIN_BLOCK_PORTION_LABEL
    }
}
